module.exports = __webpack_public_path__ + "img/20191127163431627.09017d8a.jpg";